import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "switchBar" }
const _hoisted_2 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeName) = $event)),
        type: "card",
        class: "demo-tabs",
        onTabClick: _ctx.handleClick
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "普通用户",
            name: "first"
          }),
          _createVNode(_component_el_tab_pane, {
            label: "管理用户",
            name: "second"
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onTabClick"]),
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { label: "头像" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_image, {
                style: {"width":"100px","height":"100px"},
                src: scope.row.headPic,
                fit: 'contain'
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "id",
            prop: "id"
          }),
          _createVNode(_component_el_table_column, {
            label: "昵称",
            prop: "name"
          }),
          _createVNode(_component_el_table_column, {
            label: "账户名",
            prop: "username"
          }),
          _createVNode(_component_el_table_column, {
            label: "账号类型",
            prop: "type"
          }),
          _createVNode(_component_el_table_column, {
            label: "创建时间",
            prop: "createTime"
          }),
          _createVNode(_component_el_table_column, { align: "right" }, {
            default: _withCtx((scope) => [
              (_ctx.activeName == 'second')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "danger",
                    size: "default",
                    onClick: ($event: any) => (_ctx.quash(0, scope.row))
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("转为普通用户")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.activeName == 'first')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "success",
                    size: "default",
                    onClick: ($event: any) => (_ctx.quash(2, scope.row))
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("转为管理用户")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "prev, pager, next",
          total: _ctx.total,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["total", "onCurrentChange"])
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "zhanwei3" }, null, -1))
  ], 64))
}